import { useState } from "react"
import { useTranslation } from "react-i18next"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"
import { Plus } from "lucide-react"
import { BoardCreationForm } from "./BoardCreationForm"

interface CreateBoardDialogProps {
  onBoardCreated: () => void;
}

export function CreateBoardDialog({ onBoardCreated }: CreateBoardDialogProps) {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)

  const handleSuccess = () => {
    setOpen(false)
    onBoardCreated()
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" size="sm">
          <Plus className="h-4 w-4 mr-2" />
          {t("common.boards.create")}
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("common.boards.create")}</DialogTitle>
          <DialogDescription>
            {t("common.boards.createDescription")}
          </DialogDescription>
        </DialogHeader>
        <BoardCreationForm 
          onSuccess={handleSuccess}
          onCancel={() => setOpen(false)}
        />
      </DialogContent>
    </Dialog>
  )
}